module.exports = __webpack_public_path__ + "img/moroHead.bdece081.png";